import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui'
import { green, sellColor } from '../../../../assets/colors';


export const useStyles = makeStyles()((theme) => {
    return {
        transactionTypeButton: {
            fontSize: '12px',
            fontWeight: 700,
            borderRadius: '2px',
            height: '24px',
            width: '24px',
            lineHeight: '24px',
            padding: 0
        },
        transactionTypeContainer: {
            display: 'flex',

        },
        sellTransaction: {
            background:  alpha(sellColor, 0.35),
            color: sellColor,
            borderColor: sellColor
        },
        buyTransaction: {
            background: alpha(green, 0.35),
            color: green,
            borderColor: green
        },
        nonEditable: {
            background: 'transparent',
            border: '1px solid'
        }
        
    }
})